export const MONTH_NAMES_ES = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
export const DAY_NAMES_ES_SHORT = ['L', 'M', 'X', 'J', 'V', 'S', 'D'];

export function getMonday(date) {
  const d = new Date(date);
  const day = d.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  d.setDate(d.getDate() + diff);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function getCalendarWeeks(year, month, weekCount = 5) {
  const firstDay = new Date(year, month, 1);
  const start = getMonday(firstDay);
  const weeks = [];

  for (let w = 0; w < weekCount; w += 1) {
    const weekStart = new Date(start);
    weekStart.setDate(start.getDate() + w * 7);
    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekStart.getDate() + 6);

    const days = [];
    for (let i = 0; i < 7; i += 1) {
      const d = new Date(weekStart);
      d.setDate(weekStart.getDate() + i);
      days.push(d);
    }

    weeks.push({ weekNumber: w + 1, weekStart, weekEnd, days });
  }

  return weeks;
}

export function sameDate(a, b) {
  return a.getDate() === b.getDate() && a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear();
}

export function startOfDay(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function toYmd(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function dayDiff(from, to) {
  const msPerDay = 24 * 60 * 60 * 1000;
  const a = startOfDay(from).getTime();
  const b = startOfDay(to).getTime();
  return Math.round((b - a) / msPerDay);
}

export function formatWeekShort(start, end) {
  const months = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  return `${String(start.getDate()).padStart(2, '0')} ${months[start.getMonth()]} - ${String(end.getDate()).padStart(2, '0')} ${months[end.getMonth()]}`;
}
